import { Link } from 'react-router-dom';

/**
 * Eén huishouden als kaart op het bord.
 *
 * De kaart weet niets van kolommen of instellingen: hij krijgt de velden
 * kant-en-klaar mee. Dat is met opzet — welke velden er zijn, bepaalt de
 * kolomkeuze van de organisatie, en die logica staat al één keer in het
 * overzicht. Een tweede lezing hier zou uiteenlopen met de tabel.
 *
 * **Een leeg veld valt weg.** In de tabel staat er een streepje, want daar moet
 * de rij uitlijnen met de kolomkop ernaast. Een kaart heeft die kop niet, dus
 * 'LAATSTE CONTACT —' is daar alleen ruis. Heeft een huishouden geen enkel
 * gevuld veld, dan blijft alleen het adres over — en dat is genoeg om hem te
 * herkennen en te verslepen.
 *
 * AI-CONTEXT: See docs/features/household-board-view.md
 *
 * @param {object} props
 * @param {string} props.title - Straat en huisnummer; de kop van de kaart
 * @param {string} props.to - Waar de kop naartoe linkt
 * @param {Array<{key: string, label: string, value: React.ReactNode}>} props.fields - Wat er onder de kop komt
 * @returns {JSX.Element}
 */
const HouseholdBoardCard = ({ title, to, fields }) => {
    const gevuld = (fields || []).filter((field) => field.value !== '' && field.value != null);

    return (
        <div className="household-card">
            {/* De link zit op de kop en niet op de hele kaart: de kaart is een
                sleepgreep, en dan zou elke sleep als klik kunnen eindigen. */}
            <Link className="household-card__title" to={to}>{title}</Link>

            {gevuld.length > 0 && (
                <dl className="household-card__fields">
                    {gevuld.map((field) => (
                        <div className="household-card__field" key={field.key}>
                            <dt>{field.label}</dt>
                            <dd>{field.value}</dd>
                        </div>
                    ))}
                </dl>
            )}
        </div>
    );
};

export default HouseholdBoardCard;
